import {
  INSERT_TYPE_BLANK,
  INSERT_TURBO_QUAD_OVAL,
  INSERT_TURBO_QUAD_POWER_OVAL,
  INSERT_TURBO_QUAD_2_OVAL_NUBS,
  INSERT_TURBO_QUAD_2_SEMI,
  INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  INSERT_TURBO_QUAD_CLASSIC_OVAL,
  INSERT_TURBO_QUAD_SB_POWER_LIFT,
  INSERT_TURBO_QUAD_SB_SEMI,
  INSERT_TURBO_MISS_QUAD_OVAL,
  INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  INSERT_CONTOUR_SUPERSOFT,
  INSERT_CONTOUR_SEMI_CERISE,
  INSERT_CONTOUR_SILICONE,
  INSERT_VISE_POWER_LIFT,
  INSERT_VISE_SEMI,
  INSERT_VISE_SEMI_7_8,
  INSERT_VISE_POWER_OVAL,
  INSERT_VISE_OVAL,
  INSERT_VISE_OVAL_7_8,
  INSERT_VISE_SILICONE,
  INSERT_VISE_GRAPE_NUBS,
  INSERT_VISE_POWER_LIFT_7_8,
  INSERT_VISE_POWER_OVAL_7_8,
  INSERT_ULTIMATE_TLO_OVAL,
  INSERT_ULTIMATE_TLO_LIFT,
  INSERT_ULTIMATE_TLO_OVAL_7_8,
  INSERT_ULTIMATE_TLO_LIFT_7_8,
} from './idx_data_insert_types';

export const idx_data_insert_types = [];

idx_data_insert_types.push({
  id: INSERT_TYPE_BLANK,
  type: '',
});

idx_data_insert_types.push({
  id: INSERT_TURBO_QUAD_OVAL,
  type: 'Turbo Quad Oval',
});

idx_data_insert_types.push({
  id: INSERT_TURBO_QUAD_POWER_OVAL,
  type: 'Turbo Quad Power Oval',
});

idx_data_insert_types.push({
  id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  type: 'Turbo Quad 2 Oval Nubs',
});

idx_data_insert_types.push({
  id: INSERT_TURBO_QUAD_2_SEMI,
  type: 'Turbo Quad 2 Semi',
});

idx_data_insert_types.push({
  id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  type: 'Turbo Quad Classic Power Lift',
});

idx_data_insert_types.push({
  id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  type: 'Turbo Quad Classic Oval',
});

idx_data_insert_types.push({
  id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  type: 'Turbo Quad SB Power Lift',
});

idx_data_insert_types.push({
  id: INSERT_TURBO_QUAD_SB_SEMI,
  type: 'Turbo Quad SB Semi',
});

idx_data_insert_types.push({
  id: INSERT_TURBO_MISS_QUAD_OVAL,
  type: 'Turbo Miss Quad Oval',
});

idx_data_insert_types.push({
  id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  type: 'Turbo Miss Quad Power Oval',
});

idx_data_insert_types.push({
  id: INSERT_CONTOUR_SUPERSOFT,
  type: 'Contour SuperSoft',
});

idx_data_insert_types.push({
  id: INSERT_CONTOUR_SEMI_CERISE,
  type: 'Contour Semi Cerise',
});

idx_data_insert_types.push({
  id: INSERT_CONTOUR_SILICONE,
  type: 'Contour Silicone',
});

idx_data_insert_types.push({
  id: INSERT_VISE_POWER_LIFT,
  type: 'Vise Power Lift',
});

idx_data_insert_types.push({
  id: INSERT_VISE_POWER_LIFT_7_8,
  type: 'Vise Power Lift (7/8)',
});

idx_data_insert_types.push({
  id: INSERT_VISE_POWER_OVAL,
  type: 'Vise Power Oval',
});

idx_data_insert_types.push({
  id: INSERT_VISE_POWER_OVAL_7_8,
  type: 'Vise Power Oval (7/8)',
});

idx_data_insert_types.push({
  id: INSERT_VISE_SEMI,
  type: 'Vise Semi',
});

idx_data_insert_types.push({
  id: INSERT_VISE_SEMI_7_8,
  type: 'Vise Semi (7/8)',
});

idx_data_insert_types.push({
  id: INSERT_VISE_OVAL,
  type: 'Vise Oval',
});

idx_data_insert_types.push({
  id: INSERT_VISE_OVAL_7_8,
  type: 'Vise Oval (7/8)',
});

idx_data_insert_types.push({
  id: INSERT_VISE_SILICONE,
  type: 'Vise Silicone',
});

idx_data_insert_types.push({
  id: INSERT_VISE_GRAPE_NUBS,
  type: 'Vise Grape Nubs',
});

idx_data_insert_types.push({
  id: INSERT_ULTIMATE_TLO_OVAL,
  type: 'Ultimate TLO Oval',
});

idx_data_insert_types.push({
  id: INSERT_ULTIMATE_TLO_LIFT,
  type: 'Ultimate TLO Lift',
});

idx_data_insert_types.push({
  id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  type: 'Ultimate TLO Oval (7/8)',
});

idx_data_insert_types.push({
  id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  type: 'Ultimate TLO Lift (7/8)',
});
